/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Button from "../ui/Button";
import Icon from "../ui/Icon";
import FilterCheckboxGroup from "./FilterCheckboxGroup";
import { Popover, PopoverTrigger, PopoverContent } from "../ui/Popover";
import Flex from "../ui/Flex";
import Text from "../ui/Text";

const ClearButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: inherit;
  font-size: calc(${({ theme }) => theme.fontSizes.h3} * 0.75);
  color: rgba(${({ theme }) => theme.colors.error.rgba});
  display: inline-flex;
  align-items: center;
`;

const StyledPopoverContent = styled(PopoverContent)`
  width: 380px;
  max-height: 580px;
  overflow-y: auto;
  scroll-padding-block: 4px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  left: -5px;
  box-shadow: 2px 2px 15px rgba(${({ theme }) => theme.colors.text.rgb}, 0.1);
  @media (max-width: 768px) {
    width: 280px;
    left: auto;
    right: -5px;
  }
`;

const FilterButton = ({ filterGroups = [], selectedFilters = [], onFilterChange, onClearFilters, note = "package_included_services_note" }) => {
  const hasFilterOptions = filterGroups.some((g) => g.items?.length > 0);
  if (!hasFilterOptions) return null;

  const activeCount = selectedFilters.length;

  return (
    <Popover placement="bottom-left">
      <PopoverTrigger>
        <Button size="icon" variant="outline" icon={<Icon.Filter />} count={activeCount || null} />
      </PopoverTrigger>
      <StyledPopoverContent>
        <Flex $justify="space-between" $align="center">
          <Text weight="bold" color="dark" size="large">Filter</Text>
          {activeCount > 0 && (
            <ClearButton onClick={onClearFilters}><Icon.Cross size={Icon.SIZE.SM} color="danger" />Clear all</ClearButton>
          )}
        </Flex>
        {note && <Text>{note}</Text>}
        <FilterCheckboxGroup
          groups={filterGroups}
          selectedFilters={selectedFilters}
          onFilterChange={onFilterChange}
        />
      </StyledPopoverContent>
    </Popover>
  );
};

export default FilterButton;